import React from "react";
import { Card, Typography } from "@mui/material";
import { getMostradorLabel } from "../../../../config/constants";
import EstadoEntradaBadge from "./EstadoEntradaBadge";
import DetallesTurno from "./DetallesTurno";

const SIN_TURNO = "—";

const sxTarjeta = {
    p: { xs: 2, md: 4 },
    borderRadius: 4,
    boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
    textAlign: "center",
    width: "100%",
    maxWidth: 560,
    mx: "auto",
};
// Fuente fluida: legible a varios metros en TV y sin desbordar en pantallas pequeñas
const sxNumero = { fontSize: "clamp(4rem, 10vw, 10rem)", fontWeight: 700, lineHeight: 1.1, color: "#212529" };
const sxMostrador = { fontSize: "clamp(1.5rem, 3vw, 2.5rem)", fontWeight: 500, color: "#6c757d", mt: 1 };
const sxBadge = { mt: 2 };

/**
 * Tarjeta destacada del turno que se está atendiendo. Con mostrarDetalles=false
 * no pinta los pedidos asociados
 */
const TurnoActualCard = ({ turno, mostrarDetalles = true }) => (
    <Card sx={sxTarjeta}>
        <Typography component="div" sx={sxNumero}>{turno?.numero || SIN_TURNO}</Typography>
        {turno?.mostrador && (
            <Typography sx={sxMostrador}>{getMostradorLabel(turno.mostrador)}</Typography>
        )}
        {turno?.estado && (
            <Typography component="div" sx={sxBadge}>
                <EstadoEntradaBadge estado={turno.estado} size="large" />
            </Typography>
        )}
        {mostrarDetalles && <DetallesTurno detalles={turno?.detalles} />}
    </Card>
);

export default React.memo(TurnoActualCard);
